export function isLeaderboardConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_FB_API_KEY &&
      import.meta.env.VITE_FB_AUTH_DOMAIN &&
      import.meta.env.VITE_FB_PROJECT_ID &&
      import.meta.env.VITE_FB_APP_ID,
  );
}

// Per-platform prefix for leaderboard doc-ids — keeps Poki's web_* board
// isolated from CrazyGames' cg_* board within the same Firestore project.
// Lives here (rather than in leaderboardService.ts) so consumers like
// LeaderboardModal can import it without pulling in firebase/firestore-lite.
const PLATFORM_DOC_PREFIX = import.meta.env.VITE_PLATFORM === 'crazygames' ? 'cg_' : 'web_';

export function docIdFor(playerId: string): string {
  if (playerId.startsWith('web_') || playerId.startsWith('cg_')) return playerId;
  return `${PLATFORM_DOC_PREFIX}${playerId}`;
}
